(ns ui.captions.register
  "UI register of the captions slice: the styles page under /ui/captions
   and the action handlers of the editor2 captions sidebar. Requiring
   `ui.captions.overlay` installs the captions layer of the stage."
  (:require [ui.captions.actions :as actions]
            [ui.captions.overlay]
            [ui.captions.page :as page]))

(def register
  (concat [page/page]
          actions/handlers))
